import { LoggedInHandleParamsType } from '../types';
import AbstractLoggedInHandler from './AbstractLoggedInHandler';

export default class InvitationFlowHandler extends AbstractLoggedInHandler {
  public async handle(params: LoggedInHandleParamsType): Promise<void> {
    const { decodedState, interfaces, proceedToShell, manifest } = params;
    const isInvitationFlow = decodedState?.invite === 'true';

    if (isInvitationFlow) {
      await interfaces.v1.userInterface.onboarding.joinInvitedOrganization({
        tenantId: decodedState?.orgId
      });
      return proceedToShell(manifest, interfaces, decodedState);
    }

    return super.handle(params);
  }
}
